import React, { Component } from "react";
import { Radio, Tooltip } from "antd";
import "./MarketCap.js";

class MarketCap extends Component {
	render() {
		const RadioGroup = Radio.Group;
		const RadioButton = Radio.Button;
		return (
			<section>
				<p className="panel-section-header">
					{this.props.queryTypeSingular}'s Market Cap
				</p>
				<div className="panel-section-content">
					<RadioGroup onChange={e => this.props.buildSearchQuery('marketcap', e.target.value)}>
						<Tooltip placement="bottom" title="Less than $2B">
							<RadioButton value="marketcap<2B">Small</RadioButton>
						</Tooltip>
						<Tooltip placement="bottom" title="Between $2-10B">
							<RadioButton value="2B<marketcap<10B">Mid</RadioButton>
						</Tooltip>
						<Tooltip placement="bottom" title="Between $10-200B">
							<RadioButton value="10B<marketcap<200B">Large</RadioButton>
						</Tooltip>
						<Tooltip placement="bottom" title="More than $2B">
							<RadioButton value="marketcap>200B">Mega</RadioButton>
						</Tooltip>
					</RadioGroup>
				</div>
			</section>
		);
	}
}

export default MarketCap;


// WEBPACK FOOTER //
// ./src/components/Search/PanelLeft/AcquirorsOptions/MarketCap/MarketCap.js